import { useEffect, useState } from "react";

export const useGamepadConnectionState = () => {
  const [isGamepadConnected, setGamepadConnected] = useState(false);

  const onGamepadConnected = () => {
    setGamepadConnected(true);
  };

  const onGamepadDisconnected = () => {
    setGamepadConnected(false);
  };

  useEffect(() => {
    window.addEventListener("gamepadconnected", onGamepadConnected);
    window.addEventListener("gamepaddisconnected", onGamepadDisconnected);

    return () => {
      window.removeEventListener("gamepadconnected", onGamepadConnected);
      window.removeEventListener("gamepaddisconnected", onGamepadDisconnected);
    };
  }, []);

  return { isGamepadConnected };
};
